module.exports = component => component;
